import { render, staticRenderFns } from "./LogManifestacao.vue?vue&type=template&id=ab609cae&"
import script from "./LogManifestacao.vue?vue&type=script&lang=js&"
export * from "./LogManifestacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports